<mat-card class="filter settingHeader">
  <div class="name">
    Manage Single Task Templates

    <button mat-icon-button color="primary" *ngIf="showOptionForDelete" (click)="deleteMultipleTaskTemplates()">
      <mat-icon>delete</mat-icon>
    </button>

  </div>


  <div class="quickAction">

    <mat-form-field appearance="fill">
      <mat-label>Select Category</mat-label>
      <mat-select (selectionChange)="onTaskListTabChangeForTaskImport($event)" value="My Template">
        <mat-option value="My Template">My Template</mat-option>
        <mat-option value="Organization">Organization Template</mat-option>        
      </mat-select>
    </mat-form-field>


    <!-- <mat-form-field appearance="">
      <mat-label>Search items in task status</mat-label>
      <input matInput type="text" [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
      <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field> -->



  </div>
</mat-card>


<div class="documents">

  <mat-card class="example-list rowholder" *ngIf="!ShowNoRecordFound">
    <div class="fieldRow head">
      <span class="checkBox"></span>
      <span class="templateName">Template</span>
      <span class="category">Category</span>      
      <span class="actions">Actions</span>

    </div>

    <ng-container *ngFor="let temp of taskTemplateList">
      <div class="fieldRow">


        <span class="checkBox">
         <mat-checkbox [disabled]="categoryTypeForSingleTask==2 && showOrgnizationLevelCheckbox==false" color="primary" (change)="selectRecordForDelete($event,temp)">
          </mat-checkbox>
        </span>


        <span class="templateName">
          <a>{{temp.templateName}}</a>       
        </span>

        <span class="category">         
          <ng-container *ngIf="temp.categoryName==null || temp.categoryName==''">
            <span>-</span>
          </ng-container>
          <ng-container *ngIf="temp.categoryName!=null">
            <span>{{temp.categoryName}}</span>
          </ng-container>
        </span>
     
        <span class="actions">
                
          <button mat-icon-button matTooltipClass="tooltip" matTooltip="Edit Name" class="basic"
          [disabled]="categoryTypeForSingleTask==2 && showOrgnizationLevelCheckbox==false" (click)="UpdateTaskDialog(myUpdateDialog,temp)">
          <mat-icon>edit</mat-icon>
        </button>

          <!-- <button mat-icon-button matTooltipClass="tooltip" matTooltip="Edit Name" class="basic"
            [disabled]="!temp.isActive" (click)="UpdateTaskDialog(myUpdateDialog,temp)">
            <mat-icon>edit</mat-icon>
          </button> -->

          <!-- <mat-slide-toggle color="primary" [checked]="temp.isActive" (change)="UpdateTemplateToggle(temp,$event)">
          </mat-slide-toggle> -->
                  
        </span>

      </div>
    </ng-container>

    <!-- <mat-paginator [pageIndex]="pageIndex" [pageSize]="pageSize" [length]="paginatorTotalLength" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons  (page)="CallNextPrevPageData($event)"></mat-paginator> -->
  

  </mat-card>
  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>

</div>



<ng-template #myUpdateDialog>
  <form [formGroup]="updateformDialog">
    <h2 mat-dialog-title>
      Update Single Task Template
      <button mat-icon-button (click)="closeUpdate()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">
      <mat-form-field class="example-full-width">
        <mat-label>Template Name</mat-label>
        <input matInput [required]="true" maxlength="50" placeholder="update template name"
          formControlName="taskTemplateName" />
        <mat-error *ngIf="updateformDialog.get('taskTemplateName').invalid &&
        (updateformDialog.get('taskTemplateName').dirty ||
        updateformDialog.get('taskTemplateName').touched)">
          <span>This field is mandatory.</span>
        </mat-error>
      </mat-form-field>

    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="closeUpdate()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="updateformDialog.invalid || !updateformDialog.dirty"
        (click)="UpdateTaskTemplate(updateformDialog.value)">
        Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>
    <app-loader></app-loader>
  </form>
</ng-template>



<app-loader></app-loader>